import axios from 'axios';
import { ApiUrls } from "../../constants/apiUrls";
import { LiveStreamModel } from "./liveStreamModel";
import { StreamProviderType } from './providers/types';

export class LiveStreamService {
  public Get(destination: Array<LiveStreamModel>) {
    axios.get(ApiUrls.LiveStreams).then((data) => {
      for (const i in data.data) {
        const liveStream = data.data[i];
        destination.push(new LiveStreamModel(liveStream.displayName, liveStream.streamName, liveStream.type));
      }
    });

    return destination;
  }

  public GetToken(channelName: string, provider: StreamProviderType, onSuccess: (token: any) => void) {
    const url = `${ApiUrls.StreamAdministration}/streaming/?channelName=${channelName}&provider=${provider}`;
    axios.get(url).then(data => {
      onSuccess(data.data);
    });
  }

  public GetViewerToken(channelName: string, provider: StreamProviderType, onSuccess: (token: any) => void) {
    const url = `${ApiUrls.StreamAdministration}/viewing/?channelName=${channelName}&provider=${provider}`;
    axios.get(url).then(data => {
      onSuccess(data.data);
    });
  }
  
  // Helper method to get viewer token without provider (auto-detect from backend)
  public GetViewerTokenAuto(channelName: string, onSuccess: (token: any) => void) {
    const url = `${ApiUrls.StreamAdministration}/viewing/?channelName=${channelName}`;
    axios.get(url).then(data => {
      onSuccess(data.data);
    });
  }
}